import type { ApolloClient } from '@apollo/client'
import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'
import { EmployeesFilterDataDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { createAsyncFilterWithQuery } from './createAsyncFilterWithQuery'

export const createEmployeeIdsAsyncFilter = (
  apolloClient: ApolloClient<unknown>,
  companyId: number
): FilterDefinition =>
  createAsyncFilterWithQuery({
    label: i18n.t('expenses_v2.list.header.owner'),
    apolloClient,
    query: EmployeesFilterDataDocument,
    variables: { companyId },
    mapData: (data) => {
      const employees = data?.employees?.employees || []
      return employees.map((employee) => ({
        label: employee.fullName || `Employee ${employee.id}`,
        value: employee.id,
      }))
    },
  })
